/**
 * Created by denishuang on 2017/7/28.
 */
import axios from 'vue-django/src/configs/axios'
export default {
  install (Vue) {
    Vue.prototype.$http = axios
    Vue.http = axios
  },
  $http: axios
}
axios.setBaseURL('/api/')
export const $http = axios



// WEBPACK FOOTER //
// ./src/configs/axios.js